import addons from './slices/addons';
import adminPayouts from './slices/adminPayouts';
import advert from './slices/advert';
import allShops from './slices/allShops';
import auth from './slices/auth';
import backup from './slices/backup';
import banner from './slices/banner';
import blog from './slices/blog';
import bonusList from './slices/bonus-list';
import booking from './slices/booking';
import bookingList from './slices/booking-list';
import bookingTable from './slices/booking-tables';
import bookingTime from './slices/booking-time';
import bookingZone from './slices/booking-zone';
import box from './slices/box';
import branch from './slices/branch';
import brand from './slices/brand';
import career from './slices/career';
import careerCategory from './slices/career-category';
import cart from './slices/cart';
import category from './slices/category';
import client from './slices/client';
import coupons from './slices/coupon';
import currency from './slices/currency';
import deliveries from './slices/deliveries';
import deliveryPoint from './slices/delivery-point';
import deliveryPrice from './slices/delivery-price';
import deliveryStatistics from './slices/delivery-statistic';
import deliveryboyReview from './slices/deliveryboyReview';
import deliveryman from './slices/deliveryman';
import deliverymanRequest from './slices/deliveryman-request';
import discount from './slices/discount';
import emailProvider from './slices/emailProvider';
import extraGroup from './slices/extraGroup';
import extraValue from './slices/extraValue';
import faq from './slices/faq';
import formLang from './slices/formLang';
import gallery from './slices/gallery';
import globalSettings from './slices/globalSettings';
import invite from './slices/invite';
import landingPage from './slices/landing-page';
import languages from './slices/languages';
import looks from './slices/looks';
import menu from './slices/menu';
import menuCategory from './slices/menuCategory';
import messageSubscriber from './slices/messegeSubscriber';
import mySubscriptions from './slices/my-subscriptions';
import myShop from './slices/myShop';
import notification from './slices/notification';
import notificationSummaries from './slices/notificationSummaries';
import order from './slices/order';
import orderReview from './slices/orderReview';
import orders from './slices/orders';
import orderStatus from './slices/orderStatus';
import pages from './slices/pages';
import parcelOptions from './slices/parcel-option';
import parcelOrders from './slices/parcelOrders';
import parcelReview from './slices/parcelReview';
import parcelTypes from './slices/parcelTypes';
import payment from './slices/payment';
import paymentProcess from './slices/payment-process';
import paymentPayload from './slices/paymentPayload';
import paymentToPartners from './slices/paymentToPartners';
import payoutRequests from './slices/payoutRequests';
import point from './slices/point';
import product from './slices/product';
import bonus from './slices/product-bonus';
import productReview from './slices/productReview';
import propertyGroup from './slices/propertyGroup';
import propertyValue from './slices/propertyValue';
import reciept from './slices/reciept';
import recipeCategory from './slices/recipe-category';
import refund from './slices/refund';
import categoryReport from './slices/report/categories';
import extrasReport from './slices/report/extras';
import orderReport from './slices/report/order';
import overviewReport from './slices/report/overview';
import productReport from './slices/report/products';
import revenueReport from './slices/report/revenue';
import stockReport from './slices/report/stock';
import requestModels from './slices/request-models';
import restourant from './slices/restourant';
import role from './slices/role';
import sellerCoupons from './slices/sellerCoupons';
import sellerOrders from './slices/sellerOrders';
import shop from './slices/shop';
import shopAds from './slices/shop-ads';
import shopBonus from './slices/shop-bonus';
import shopLocations from './slices/shop-locations';
import shopReviews from './slices/shop-reviews';
import shopCategory from './slices/shopCategory';
import closeDates from './slices/shopClosedDays';
import shopTag from './slices/shopTag';
import workingDays from './slices/shopWorkingDays';
import sms from './slices/sms-geteways';
import statisticsCount from './slices/statistics/count';
import orderCounts from './slices/statistics/orderCounts';
import orderSales from './slices/statistics/orderSales';
import sales from './slices/statistics/sales';
import statisticsSum from './slices/statistics/sum';
import topCustomers from './slices/statistics/topCustomers';
import topProducts from './slices/statistics/topProducts';
import storeis from './slices/storeis';
import subscriber from './slices/subscriber';
import theme from './slices/theme';
import todo from './slices/todo';
import transaction from './slices/transaction';
import unit from './slices/unit';
import user from './slices/user';
import waiterOrder from './slices/waiterOrder';
import wallet from './slices/wallet';
import warehouse from './slices/warehouse';
import carts from './slices/carts';
import cartNotes from './slices/cartNotes';
import dashboardFilter from './slices/dashboardFilter';
import lottery from './slices/lottery';

//deliveryzone
import deliveryArea from './slices/deliveryzone/area';
import deliveryCity from './slices/deliveryzone/city';
import deliveryCountries from './slices/deliveryzone/country';
import deliveryRegion from './slices/deliveryzone/region';

const rootReducer = {
  deliveryCountries,
  deliveryRegion,
  deliveryCity,
  deliveryArea,
  bookingList,
  booking,
  bookingTime,
  bookingZone,
  bookingTable,
  waiterOrder,
  pages,
  career,
  careerCategory,
  menuCategory,
  sms,
  coupons,
  sellerCoupons,
  bonusList,
  sellerOrders,
  deliveryboyReview,
  shopTag,
  deliveryStatistics,
  addons,
  branch,
  refund,
  closeDates,
  workingDays,
  emailProvider,
  storeis,
  messageSubscriber,
  subscriber,
  bonus,
  shopBonus,
  shop,
  orderStatus,
  shopCategory,
  languages,
  cart,
  menu,
  formLang,
  order,
  category,
  brand,
  banner,
  product,
  restourant,
  unit,
  orders,
  currency,
  discount,
  deliveries,
  blog,
  notification,
  notificationSummaries,
  deliveryman,
  user,
  extraGroup,
  extraValue,
  payment,
  invite,
  faq,
  client,
  transaction,
  allShops,
  auth,
  backup,
  productReview,
  orderReview,
  globalSettings,
  statisticsCount,
  statisticsSum,
  topProducts,
  topCustomers,
  orderCounts,
  orderSales,
  sales,
  myShop,
  wallet,
  payoutRequests,
  theme,
  point,
  role,
  productReport,
  categoryReport,
  orderReport,
  stockReport,
  revenueReport,
  overviewReport,
  extrasReport,
  adminPayouts,
  todo,
  paymentPayload,
  box,
  recipeCategory,
  reciept,
  landingPage,
  parcelOrders,
  parcelTypes,
  advert,
  shopAds,
  parcelOptions,
  parcelReview,
  requestModels,
  paymentToPartners,
  shopReviews,
  shopLocations,
  propertyGroup,
  propertyValue,
  deliveryPoint,
  deliveryPrice,
  warehouse,
  looks,
  deliverymanRequest,
  gallery,
  mySubscriptions,
  paymentProcess,
  carts,
  cartNotes,
  dashboardFilter,
  lottery,
};

export default rootReducer;
